import { useRef as c, useState as m, useEffect as d, useCallback as R, useImperativeHandle as k } from "react";
const v = (f) => {
  const {
    active: u = !0,
    duration: e,
    callback: s
  } = f, r = c(null), n = c(), t = c(e), [l, o] = m(e);
  d(() => {
    if (u) {
      const i = () => {
        t.current--, t.current === 0 && (s(r.current), t.current = e), o(t.current), n.current = setTimeout(i, 1e3);
      };
      s(r.current), i();
    }
    return () => {
      n.current && clearTimeout(n.current);
    };
  }, [u, e]);
  const a = R(() => {
    t.current = e, o(t.current);
  }, [e]);
  return k(r, () => ({
    reset: a
  }), [a]), {
    remainSecond: l
  };
};
export {
  v as default
};
//# sourceMappingURL=useRecursiveCalling.js.map
